import React from "react";
import {
    Image,
    Flex
} from "@chakra-ui/react";


import "../styles/about.css";

import Card from "../components/Card"
import CardGrid from "../components/CardGrid";
import TextFlex from "../components/TextFlex";

import roster from "../data/roster.json"


function GridItem(props) {
    const { item, ...rest } = props

    return (
        <Card flexDirection={"column"} {...rest}>
            <Image src={item.image} />
            <Flex className="grid-content leader-card" flexDirection={"column"}>
                <h1>{item.name}</h1>
                <h2>{item.position}</h2>
                <p>{item.bio}</p>
            </Flex>
        </Card>
    );
}

export default function About() {
    return (
        <>
            <TextFlex>
                <Flex flexDirection={"column"}>
                    <h1 className={"title"}>Our Mission</h1>
                    <p>
                        Our definition of computer graphics includes but is not limited to the generation of imagery using computing
                        techniques for video games, movies, animations, entertainment, architectural visualizations, advertising, and
                        digital art. Our mission is to provide campus members, both enthusiasts and newcomers, with an opportunity to
                        freely explore, discuss, and engage with the field of computer graphics. Our purpose is to develop, maintain,
                        and enrich the computer graphics community on campus.
                    </p>
                </Flex>
            </TextFlex>
            <CardGrid items={roster} title={"Club Leaders"} component={{ "type": GridItem }} />
        </>
    );
}
